(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-navigation"]) return;
  try {
    
const announcement=document.querySelector('.vv-announcement');
if(announcement){const label=announcement.querySelector('span');const button=announcement.querySelector('button');const initial=label.textContent;const messages=[initial,announcement.dataset.message,announcement.dataset.story];let position=0;let running=!matchMedia('(prefers-reduced-motion: reduce)').matches;const apply=()=>{button.textContent=running?'Ⅱ':'▶';button.setAttribute('aria-label',running?announcement.dataset.pause:announcement.dataset.play)};apply();button.addEventListener('click',()=>{running=!running;apply()});setInterval(()=>{if(running&&!document.hidden)label.textContent=messages[++position%messages.length]},6000)}
if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.animate([{opacity:.25,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:600,easing:'ease-out'});observer.unobserve(entry.target)}}),{threshold:.1});document.querySelectorAll('.vv-stop,.vv-story,.vv-gift').forEach(el=>observer.observe(el))}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vv-story"]) return;
  try {
    
document.querySelectorAll('.vv-floating').forEach(link=>{const update=()=>link.classList.toggle('vv-shown',window.scrollY>750);window.addEventListener('scroll',update,{passive:true});update()});

  } catch(e) { console.error(e); }
})();
})();
